var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 49.862c7.313-5.138 12-13.012 12-21.863C64 12.537 49.675 0 32 0S0 12.537 0 28c0 8.838 4.688 16.725 12 21.863V58c0 3.313 2.688 6 6 6h6v-6c0-1.1.9-2 2-2s2 .9 2 2v6h8v-6c0-1.1.9-2 2-2s2 .9 2 2v6h6c3.313 0 6-2.688 6-6zM12 32a8 8 0 1 1 16 0 8 8 0 1 1-16 0m32-8a8 8 0 1 1 0 16 8 8 0 1 1 0-16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkull);
export default __webpack_public_path__ + "static/media/skull.68f6b0e42b732381858ccff585dcb22c.svg";
export { ForwardRef as ReactComponent };